import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { themeMediaQuery } from '@utils/styledTheme.util';

export interface SliderWidth {
  sm: number;
  mobile: number;
}

export const Wrapper = styled.div<SliderWidth>`
  width: ${({ mobile }) => mobile * 2}px;
  ${themeMediaQuery('sm')} {
    width: ${({ sm }) => sm * 2}px;
  }
`;

export const Container = styled(Box)<SliderWidth & { speed: number; scrollName: string; stopOnHover?: boolean }>`
  justify-content: left;
  animation: infinite-slider-${({ scrollName }) => scrollName}-scroll ${({ speed }) => speed}s linear infinite;
  :hover {
    animation-play-state: ${({ stopOnHover }) => (stopOnHover ? 'paused' : 'running')};
  }

  @keyframes infinite-slider-${({ scrollName }) => scrollName}-scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-${({ mobile }) => mobile}px);
    }
  }
  ${themeMediaQuery('sm')} {
    @keyframes infinite-slider-${({ scrollName }) => scrollName}-scroll {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-${({ sm }) => sm}px);
      }
    }
  }
`;
